import { render, staticRenderFns } from "./data-export.vue?vue&type=template&id=1f9bdc5c&"
import script from "./data-export.vue?vue&type=script&lang=ts&"
export * from "./data-export.vue?vue&type=script&lang=ts&"
import style0 from "./data-export.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports